import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import * as _ from 'lodash';
import { IdDescricao } from './id-descricao';

@Component({
    template: ''
})
export abstract class ComboIdDescricaoComponent<T extends IdDescricao> implements OnInit {

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;
  @Input() label;
  @Input() campoPesquisavel = 'descricao';
  @Input() fxFlexOffset = "20px";

  @Output() valorChange = new EventEmitter();

  dados: T[] = [];
  data: any = {};

  ngOnInit(): void {
    this.data = Date.now();

    setTimeout(() => {
      this.getDados().subscribe((result: T[]) => {
        this.dados = result;
        console.log('dadosCombo = ', result);
        this.preencherCombo();

        this.ordenarDados();
      });
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
      this.preencherCombo();
    }
  }

  private preencherCombo() {
    if (this.selecionado && this.selecionado.descricao) {
      const existe = this.dados.some(item =>
        item.id === this.selecionado.id && item.descricao === this.selecionado.descricao
      );
      if (!existe) {
        this.dados.push(this.selecionado);
      }
    }
    if (this.selecionado && this.selecionado.id && this.dados.length) {
      this.selecionado = _.find(this.dados, { id: this.selecionado.id });
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

  protected ordenarDados() {
    this.dados.sort((a: any, b: any) => {
      if (a.descricao > b.descricao) return 1;
      return 0;
    });
  }

  protected abstract getDados(): any;
}
